import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { INewDetails } from './model/INewDetails';
import { TranslateService } from '@ngx-translate/core';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-new-detail-card',
  templateUrl: './new-detail-card.component.html',
  styleUrls: ['./new-detail-card.component.scss']
})
export class NewDetailCardComponent implements OnInit {
  APIURL: any = environment.apiUrl;
  @Input() data: any;
  @Input() IsFTLShow: boolean = false;
  @Input() NewcardDetails: INewDetails;
  @Input() isTableCardView: any;
  @Output() onActionClickOutput = new EventEmitter<any>();
  @Input() isDiffTablePattern: any;
  @Input() noOfColumnToShowOnModile: any;
  //added by BURHAN - 13-may-2026
  @Input() showAttachmentButton: boolean = false;
  @Input() attachmentData: any;
  @Output() onAttachmentAction = new EventEmitter<any>();
  //end by BURHAN - 13-May-2026
  isMobileView: any;
  constructor(
    private translate: TranslateService,
    private mobileDetectionService: MobileDetectionService) { }
  ngOnInit(): void {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    setTimeout(() => {
      if (this.NewcardDetails.cartType == 'Role') {
        document.getElementById("card_body").classList.remove("h-100");
      }
    }, 1000);
  }

  gotToPage() {

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  openPhoneHyperLink(phone: any) {
    const phoneLink = "tel:+" + phone;
    window.location.href = phoneLink;
  }

  openEmailHyperLink(email: any) {
    const phoneLink = "mailto:+" + email;
    window.location.href = phoneLink;
  }

  onActionClick(row, event,) {
    this.onActionClickOutput.emit(event);
    return;
  }

  getCurruncyValue = (value: number): string => {
    if (value) {
      return (this.NewcardDetails.currencySymbol ? this.NewcardDetails.currencySymbol : "") + (value).toLocaleString('en-US');
    }
    return "";
  }

  getImageUrl(imageUrl: string): string {
    // Check if the imageUrl is null, undefined, or contains 'null'
    if (!imageUrl || imageUrl.includes('null')) {
      return '../../../../assets/driver/driver_icon.png';
    }
    console.log("isUserDetails", imageUrl);
    return imageUrl;
  }

  setDefaultImg(event : Event){
    const img = event.target as HTMLImageElement;
    img.src = '../../../../assets/driver/driver_icon.png';
  }

  //added by BURHAN - 13-May-2026
  onSelectAttachmentItem(event: any) {
    this.onAttachmentAction.emit(event);
  }
  //end by BURHAN

}
